import $ from "jquery";
import { EldmlTransform } from "./EldmlTransform";

export class VerticalTransform extends EldmlTransform {
  apply() {
    this.selector.find('[vertical="true"]').each(function (_: any, element: Element) {
      $(element).wrapInner("<div></div>");
    });
  }
}
